import client from "@/plugins/axios-plugin";
import Vue from "vue";

export default async function(){
    const token =  Vue.$cookies.get("token");
    if(!token) return null;
    try {
        const data = await client.get("/user/me", {
            headers: {
                authorization: token
            }
        })
        return data.data;
    } catch (error) {
        
    }
    return null;
}